import { useContext } from 'react'
import { GlobalContext } from '../GlobalContext'

import { getDate } from '../utils/getDate'

type Props = {
  questionAnswer: any
  timeZoneString?: string
}

function FormatQuestionAnsweredBy({
  questionAnswer,
  timeZoneString = 'Europe/London'
}: Props) {

  const {
    tableData,
    t
  } = useContext(GlobalContext)



  return <span>
    {!questionAnswer.CognitoUserId && !questionAnswer.GuestUserName && t('Dashboard.FormatQuestionAnsweredBy.guestUser')}
    {!questionAnswer.CognitoUserId && questionAnswer.GuestUserName && t('Dashboard.FormatQuestionAnsweredBy.guestUserWithName', { name: questionAnswer.GuestUserName })}
    
    {questionAnswer.CognitoUserId && <>

      {tableData &&
        tableData.Users &&
        tableData.Users[questionAnswer.CognitoUserId] &&
        tableData.Users[questionAnswer.CognitoUserId]['UserName'] ?
        t('Dashboard.FormatQuestionAnsweredBy.userName', { name: tableData.Users[questionAnswer.CognitoUserId]['UserName'] }) :
        t('Dashboard.FormatQuestionAnsweredBy.userId', { id: questionAnswer.CognitoUserId })}

    </>}
    {questionAnswer.AuthenticationEntraTenantId && t('Dashboard.FormatQuestionAnsweredBy.loggedInWithEntra')}

    {questionAnswer.AnswerTimestamp && t('Dashboard.FormatQuestionAnsweredBy.at', { date: getDate(questionAnswer.AnswerTimestamp, 'formattedDateAndTime') })}
  </span>
}

export default FormatQuestionAnsweredBy